import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const UserTypeToggleRoot = styled.button`
  padding: 0 0.5rem;
  color: ${color("filter")};
  cursor: pointer;
  vertical-align: middle;
`;
